import { Tooltip } from 'antd';
import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

const useStyles = createUseStyles((theme: ThemeType) => ({
  tooltip: {
    '& .ant-tooltip-inner > div': {
      color: `${theme.color.semantic.text.inverse} !important`,
    },
    '& .ant-tooltip-inner > div > div': {
      color: `${theme.color.semantic.text.inverse} !important`,
    },
    '& .ant-tooltip-inner > div > div > a': {
      color: `${theme.color.semantic.text.inverse} !important`,
    },
    '& .ant-tooltip-inner > div > div > div': {
      color: `${theme.color.semantic.text.inverse} !important`,
    },
    '& .ant-tooltip-inner > span': {
      color: `${theme.color.semantic.text.inverse} !important`,
    },
    '& .ant-tooltip-inner > button': {
      color: `${theme.color.semantic.text.inverse} !important`,
    },
  },
}));

interface CustomTableCellProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
  children?: React.ReactNode;
  sameTooltipAsElem?: boolean;
  colWidth?: number;
  enableTextWrap?: boolean;
}

const CustomTableCell: React.FC<CustomTableCellProps> = (props) => {
  const { children, sameTooltipAsElem, colWidth, enableTextWrap = false, ...restProps } = props;
  const classes = useStyles();
  const childRef = React.useRef<HTMLDivElement>(null);

  const cellContent = (
    <div
      ref={childRef}
      style={{
        cursor: 'default',
        overflow: 'hidden',
        ...(enableTextWrap ? {
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
        } : {
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        })
      }}
    >
      {children}
    </div>
  );

  const cellContentWithOverflow = (
    <Tooltip
      overlayClassName={sameTooltipAsElem ? undefined : classes.tooltip}
      title={children}
    >
      {cellContent}
    </Tooltip>
  );

  return <td {...restProps}>{cellContent}</td>;
};

export default React.memo(CustomTableCell);
